import { Badge, BadgeProps } from 'antd';
import React, { FC } from 'react';

const DgBadge: FC<BadgeProps> = ({ ...props }) => {
	return <Badge {...props}></Badge>;
};

export default DgBadge;
